/**
 * Zondela Destinations
 * Handles client-side category filtering (instant, no reload), sorting
 * (recommended / by date / random) and carousel arrow navigation for the
 * Zondela destination cards section.
 */
(function () {
  function initSection(section) {
    var track = section.querySelector('[data-zondela-track]');
    var emptyMessage = section.querySelector('[data-zondela-empty]');
    var filters = section.querySelectorAll('[data-zondela-filters] .zondela-filter');
    var sortWrap = section.querySelector('[data-zondela-sort-wrap]');
    var sortButtons = section.querySelectorAll('[data-zondela-sort-wrap] .zondela-sort-btn');
    var prevBtn = section.querySelector('[data-zondela-prev]');
    var nextBtn = section.querySelector('[data-zondela-next]');

    if (!track) return;

    var cards = Array.prototype.slice.call(track.querySelectorAll('.zondela-card'));
    var originalOrder = cards.slice();

    function applyFilter(filterValue) {
      var visibleCount = 0;

      cards.forEach(function (card) {
        var types = (card.getAttribute('data-experience-type') || '').split(/\s+/).filter(Boolean);
        var show = filterValue === 'all' || types.indexOf(filterValue) !== -1;
        card.hidden = !show;
        if (show) visibleCount += 1;
      });

      if (emptyMessage) {
        emptyMessage.hidden = visibleCount > 0;
      }

      track.scrollTo({ left: 0, behavior: 'auto' });
      updateArrowState();
    }

    function reorder(orderedCards) {
      orderedCards.forEach(function (card) {
        track.appendChild(card);
      });
      track.scrollTo({ left: 0, behavior: 'auto' });
      updateArrowState();
    }

    function applySort(sortValue) {
      var ordered;

      if (sortValue === 'date') {
        ordered = originalOrder.slice().sort(function (a, b) {
          var da = a.getAttribute('data-departure') || '';
          var db = b.getAttribute('data-departure') || '';
          if (!da && !db) return 0;
          if (!da) return 1;
          if (!db) return -1;
          return da < db ? -1 : (da > db ? 1 : 0);
        });
      } else if (sortValue === 'random') {
        ordered = originalOrder.slice();
        for (var i = ordered.length - 1; i > 0; i--) {
          var j = Math.floor(Math.random() * (i + 1));
          var tmp = ordered[i];
          ordered[i] = ordered[j];
          ordered[j] = tmp;
        }
      } else {
        ordered = originalOrder.slice();
      }

      reorder(ordered);
    }

    filters.forEach(function (button) {
      button.addEventListener('click', function () {
        filters.forEach(function (btn) {
          btn.classList.remove('is-active');
          btn.setAttribute('aria-selected', 'false');
        });
        button.classList.add('is-active');
        button.setAttribute('aria-selected', 'true');
        applyFilter(button.getAttribute('data-filter'));
      });
    });

    sortButtons.forEach(function (button) {
      button.addEventListener('click', function () {
        sortButtons.forEach(function (btn) {
          btn.classList.remove('is-active');
          btn.setAttribute('aria-selected', 'false');
        });
        button.classList.add('is-active');
        button.setAttribute('aria-selected', 'true');
        applySort(button.getAttribute('data-sort'));
      });
    });

    function getScrollStep() {
      var visibleCard = cards.find(function (card) {
        return !card.hidden;
      });
      if (!visibleCard) return track.clientWidth;

      var gap = parseFloat(getComputedStyle(track).gap) || 0;
      return visibleCard.getBoundingClientRect().width + gap;
    }

    function updateArrowState() {
      if (!prevBtn && !nextBtn) return;
      var maxScroll = track.scrollWidth - track.clientWidth - 1;

      if (prevBtn) prevBtn.disabled = track.scrollLeft <= 0;
      if (nextBtn) nextBtn.disabled = track.scrollLeft >= maxScroll;
    }

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -getScrollStep(), behavior: 'smooth' });
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: getScrollStep(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', updateArrowState);
    window.addEventListener('resize', updateArrowState);

    // Apply default sort chosen in the Theme Editor (if any) on load.
    if (sortWrap) {
      var defaultSort = sortWrap.getAttribute('data-default-sort') || 'default';
      if (defaultSort !== 'default') {
        sortButtons.forEach(function (btn) {
          var isMatch = btn.getAttribute('data-sort') === defaultSort;
          btn.classList.toggle('is-active', isMatch);
          btn.setAttribute('aria-selected', isMatch ? 'true' : 'false');
        });
        applySort(defaultSort);
      }
    }

    updateArrowState();
  }

  function init() {
    document.querySelectorAll('.zondela-destinations').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.zondela-destinations');
    if (section) initSection(section);
  });
})();
